import PublishedLegalPage from "./PublishedLegalPage"
import { LEGAL } from "../../config/legal"

// /privacy-policy: the MyAdvisorRetirement Privacy Policy as published on the product host (RB-326)
const PrivacyPolicy = () => (
    <PublishedLegalPage title="Privacy Policy" url={LEGAL.privacyUrl} version={LEGAL.privacyVersion} />
)

export default PrivacyPolicy
